import messageResource from '../../messageResource'
import {hasRuleId, PasswordValidatorId} from './PasswordSettings'

function addTips(tips, settings, rule, tipFn) {
    if (hasRuleId(settings, rule)) {
        let [key, ...params] = tipFn();
        tips.push(messageResource.getMessage(key, params));
    }
}


export class LengthValidator {
    static addTips(tips, settings) {
        addTips(tips, settings, PasswordValidatorId.LENGTH_VALIDATOR, () => ["password_validation.length.hint", settings.minimalLength]);
    }

    static addMessage(messages, violatedRules, settings) {
        if (violatedRules.has(PasswordValidatorId.LENGTH_VALIDATOR)) {
            messages.push(messageResource.getMessage("password_validation.length", [settings.minimalLength]))
        }
    }
}

export class CharsValidator {

    static RuleToName = {
        [PasswordValidatorId.UPPERCASE_VALIDATOR]: "password_validation.characters.uppercase",
        [PasswordValidatorId.LOWERCASE_VALIDATOR]: "password_validation.characters.lowercase",
        [PasswordValidatorId.NUMBER_VALIDATOR]: "password_validation.characters.number",
        [PasswordValidatorId.SPECIAL_VALIDATOR]: "password_validation.characters.special",
    }
    static MyRules = new Set(Object.keys(CharsValidator.RuleToName));
    static MessageTemplates = {
        1: "password_validation.characters.1",
        2: "password_validation.characters.2",
        3: "password_validation.characters.3",
        4: "password_validation.characters.4",
    }


    static addTips(tips, settings) {
        addTips(tips, settings, PasswordValidatorId.UPPERCASE_VALIDATOR, () => ["password_validation.characters.uppercase.hint"]);
        addTips(tips, settings, PasswordValidatorId.LOWERCASE_VALIDATOR, () => ["password_validation.characters.lowercase.hint"]);
        addTips(tips, settings, PasswordValidatorId.NUMBER_VALIDATOR, () => ["password_validation.characters.number.hint"]);
        addTips(tips, settings, PasswordValidatorId.SPECIAL_VALIDATOR, () => ["password_validation.characters.special.hint"]);
    }

    static addMessage(messages, violatedRules, settings) {
        let reallyViolated = new Set();
        for (let rule of this.MyRules) {
            if (violatedRules.has(rule)) {
                reallyViolated.add(rule);
            }
        }
        if (reallyViolated.size) {
            let template = CharsValidator.MessageTemplates[reallyViolated.size];
            let params = [...reallyViolated].map(rule => this.RuleToName[rule]).map(name => messageResource.getMessage(name));
            messages.push(messageResource.getMessage(template, params));
        }
    }
}


export default [LengthValidator, CharsValidator]


// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordValidators.js